import { render, staticRenderFns } from "./couponLists.vue?vue&type=template&id=0cb42b7c&scoped=true&"
import script from "./couponLists.vue?vue&type=script&lang=js&"
export * from "./couponLists.vue?vue&type=script&lang=js&"
import style0 from "./couponLists.vue?vue&type=style&index=0&id=0cb42b7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb42b7c",
  null
  
)

export default component.exports